import collect, { Collection } from 'collect.js';
// @ts-ignore
import { traverse } from '../helpers';
import { EventEmitter } from '.';
import { NodeModel } from '../models';

export type TLocatorOptions = {
  getNextParent?: boolean;
}

export abstract class NodeProvider extends EventEmitter {
  public collection: Collection<any> = collect();

  public activeRoute?: any = undefined;

  public lastActive?: any;

  deactivateOther(route: NodeModel) {
    this.collection.transform((item: NodeModel) => {
      if (item !== route && !item.sameVisualGroupAs(route)) {
        item.deactivate();
      }

      return item;
    });

    return this;
  }

  deactivateAll(collection: Collection<NodeModel> = this.collection) {
    collection.transform(item => {
      if (!item.deactivate) { return item; }

      item.deactivate();

      if (item.isExpandable) {
        this.deactivateAll(item.collection);
      }

      return item;
    });

    return this;
  }

  setActiveRoute(route: NodeModel) {
    this.activeRoute = route;
  }

  public abstract getNextRoute(locatorOptions?: TLocatorOptions): unknown

  public getPrevRoute() {
    const { activeRoute } = this;

    if (!activeRoute) {
      throw new Error('To determine a previous route, an active route should be set.');
    }

    const activeIndex: number = this.collection.search(((i: any) => i.key === activeRoute.key), false) || 0;

    // The active route is a first route, no prev nodes
    if (activeIndex === 0) { return null; }

    return this.collection.get(activeIndex - 1);
  }

  public abstract getPrevRoutes(): Collection<any>

  public getNextRoutes(): Collection<any> {
    const { activeRoute = this.collection.first() } = this;
    const activeIndex: number = this.collection.search(((i: any) => i.key === activeRoute.key), false) || 0;

    return this.collection.slice(activeIndex + 1);
  }

  public traverse(cb: (item: NodeModel) => boolean): NodeModel | null {
    return traverse(cb, this.collection);
  }
}
